import { VideoTutorial } from "./start.interface";

export const VIDEO_TUTORIALS_BY_LANGUAGE: Record<string, VideoTutorial[]> = {
  es: [
    {
      id: "gSignatureQueEs",
      title: "gSignature ¿qué es?",
      duration: "2m",
      thumbnail: "https://img.youtube.com/vi/FDny5rKT89s/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=FDny5rKT89s",
    },
    {
      id: "gSignatureManual",
      title: "gSignature - Manual de instrucciones",
      duration: "10m",
      thumbnail: "https://img.youtube.com/vi/L9LbwE3yI_c/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=L9LbwE3yI_c",
    },
    {
      id: "gSignatureEmailFooters",
      title: "Rodapés de e-mail gSignature gerenciados centralmente",
      duration: "4m",
      thumbnail: "https://img.youtube.com/vi/Mm1DBn_3lU4/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=Mm1DBn_3lU4",
    },
  ],
  pl: [
    {
      id: "gSignatureCoToJest",
      title: "gSignature co to jest",
      duration: "2m",
      thumbnail: "https://img.youtube.com/vi/ilW56U5EPuM/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=ilW56U5EPuM",
    },
    {
      id: "gSignatureInstrukcja",
      title: "gSignature - Instrukcja obsługi",
      duration: "10m",
      thumbnail: "https://img.youtube.com/vi/rb4e9cFCddM/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=rb4e9cFCddM",
    },
    {
      id: "gSignatureStopkiEmail",
      title: "gSignature stopki email centralnie zarządzane",
      duration: "4m",
      thumbnail: "https://img.youtube.com/vi/m3deWhayQ6w/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=m3deWhayQ6w",
    },
  ],
  en: [
    {
      id: "gSignatureWhatIsIt",
      title: "gSignature what is it",
      duration: "2m",
      thumbnail: "https://img.youtube.com/vi/mEI_bYtqrt0/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=mEI_bYtqrt0",
    },
    {
      id: "gSignatureTutorial",
      title: "gSignature - Tutorial step by step",
      duration: "10m",
      thumbnail: "https://img.youtube.com/vi/uL6aGrEuJ-s/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=uL6aGrEuJ-s",
    },
    {
      id: "gSignatureEmailFooters",
      title: "gSignature email footers centrally managed",
      duration: "4m",
      thumbnail: "https://img.youtube.com/vi/hdZijvUwAxU/hqdefault.jpg",
      youtubeUrl: "https://www.youtube.com/watch?v=hdZijvUwAxU",
    },
  ],
};

export const getVideoTutorialsForLanguage = (
  language: string,
): VideoTutorial[] => {
  return (
    VIDEO_TUTORIALS_BY_LANGUAGE[language] || VIDEO_TUTORIALS_BY_LANGUAGE.en
  );
};

export const TUTORIAL_VIDEO_URLS: Record<string, string> = {
  pl: "https://www.youtube.com/watch?v=rb4e9cFCddM",
  es: "https://www.youtube.com/watch?v=L9LbwE3yI_c",
  en: "https://www.youtube.com/watch?v=uL6aGrEuJ-s",
};

export const getTutorialVideoUrl = (language: string): string => {
  return TUTORIAL_VIDEO_URLS[language] || TUTORIAL_VIDEO_URLS.en;
};

export const VIDEO_ID_MAPPING: Record<string, string[]> = {
  gSignatureCoToJest: ["gSignatureWhatIsIt", "gSignatureQueEs"],
  gSignatureWhatIsIt: ["gSignatureCoToJest", "gSignatureQueEs"],
  gSignatureQueEs: ["gSignatureCoToJest", "gSignatureWhatIsIt"],

  gSignatureInstrukcja: ["gSignatureTutorial", "gSignatureManual"],
  gSignatureTutorial: ["gSignatureInstrukcja", "gSignatureManual"],
  gSignatureManual: ["gSignatureInstrukcja", "gSignatureTutorial"],

  gSignatureStopkiEmail: ["gSignatureEmailFooters"],
  gSignatureEmailFooters: ["gSignatureStopkiEmail"],
};

export const getRelatedVideoIds = (videoId: string): string[] => {
  return VIDEO_ID_MAPPING[videoId] || [];
};
